<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <span :class="{'font' : isMobile}">COPYRIGHT @ {{ new Date().getFullYear() }} TIMELESS, All rights Reserved. </span>
        <span :class="{'font' : isMobile}"> Version: {{ hash() }}</span>
    </footer>
</template>

<script>

export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },
    },
    methods:{
        isMobile(){
            return screen.width < 500 ? true : false;
        },
        hash() {
          return process.env.VUE_APP_GIT_HASH
        }
    }
}
</script>
<style>
    .font{
        font-size: 12px;
    }
</style>
